import { render, staticRenderFns } from "./miniModal.vue?vue&type=template&id=5fedfa01&scoped=true&"
import script from "./miniModal.vue?vue&type=script&lang=js&"
export * from "./miniModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fedfa01",
  null
  
)

export default component.exports